// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"0a1d566a","250":"73982c27","407":"f38d3c11","436":"98a13848","453":"f394a27d","455":"8e77704e","501":"a413824d","595":"7e97d784","596":"72e67ee3","606":"eb2eb96d","691":"8d57ba31","821":"c482dbbc","925":"d93c894e","969":"d04a2a83"}[chunkId] + ".chunk.js";
};